import './style.scss';
import { BankStepProps } from '../hooks';
import { useSelectBank, useSelectBranch } from './hooks';
import { BankButton, BankButtonProps } from '../module';


export type SelectBankProps = {
  onSelected : (value : string) => void;
  onClosed? : () => void;
  bankList : string[];
} &BankButtonProps & BankStepProps

export const SelectBank = (props : SelectBankProps) => {
  const selectProps = useSelectBank(props.setModalStep, props.onSelected);
  return (
    <form onSubmit={selectProps.formik.handleSubmit} className='selectTemplete'>
      <SelectTemplete {...selectProps.selectedBankProps} list={props.bankList}/>
      <BankButton {...props}{...selectProps.selectedBankProps}/>
    </form>      
  );
};

export type SelectBranchProps = {
  onSelected : (value : string) => void;
  onClosed? : () => void;
  branchList : string[];
} &BankButtonProps & BankStepProps

export const SelectBranch = (props : SelectBranchProps) => {
  const selectProps = useSelectBranch(props.setModalStep, props.onClosed!, props.onSelected);
  return (
    <form onSubmit={selectProps.formik.handleSubmit} className='selectTemplete'>
      <SelectTemplete {...selectProps.selectedBranchProps} list={props.branchList}/>
      <BankButton {...props}{...selectProps.selectedBranchProps}/>
    </form>      
  );
};

type SelectTempleteProps = {
  value : string;
  list: string[];
  onClick : (value : string) => void
}

const SelectTemplete = ( {value, list, onClick} : SelectTempleteProps) => {

  return (
    <div className='selectTemplete_wrapper'>
      <div className="selectTemplete_list">
        <ul className='selectTemplete_list_ul'>
          {list.map((text) => (
            <li 
              className={`selectTemplete_list_ul_li ${value === text ? 'selected' : ''}`}
              key={text}  
              onClick={() => onClick(text)}
            >
              {text}
            </li>
          ))}
        </ul>
      </div>
    </div>   
  );
}